
import { showPostgradErrorToast } from '@/helpers/postgradErrorToast';
import { StudyPlanningBreakpointModel } from '@/models/studyPlanning/StudyPlanningBreakpointModel';
import { CourseModel } from '@descomplica/dex-models';
import { Loading } from '@descomplica/vue-components';
import Vue from 'vue';
import BreakpointsModal from './BreakpointsModal.vue';
import InvalidStudyPlanningModal from './InvalidStudyPlanningModal.vue';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';
import { PostgradTrialStatus } from '@/models/postgradTrial/PostgradTrialModel';

interface Data {
  isFetchingBreakpoints: boolean;
}

export default Vue.extend({
  components: {
    BreakpointsModal,
    InvalidStudyPlanningModal,
    Loading,
  },
  data(): Data {
    return {
      isFetchingBreakpoints: true,
    };
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    currentChimeraCourse(): ChimeraCourseModel | null {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    getTrialStatusByDescomplicaCourseId(): PostgradTrialStatus {
      return this.$store.getters.getTrialStatusByDescomplicaCourseId(
        this.currentChimeraCourse?._id,
      );
    },
    studyPlanningBreakpoints(): StudyPlanningBreakpointModel[] {
      return this.$store.getters.studyPlanningBreakpoints;
    },
    hasPossibleBreakpoints(): boolean {
      return this.studyPlanningBreakpoints.some((breakpoint) => breakpoint.isPossible);
    },
    showInvalidStudyPlanningModal(): boolean {
      return !this.hasPossibleBreakpoints;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('GET_STUDY_PLANNING_BREAKPOINTS', this.currentCourse.id);
    } catch (err) {
      showPostgradErrorToast(err as Error, this.$t('getStudyPlanningBreakpointsError').toString());
      Analytics.trackEvent(EVENT_LABELS.postgradStudyPlanningBreakpointsError, {
        course: this.currentCourse.name,
        category: 'pos',
        ...this.getTrialStatusByDescomplicaCourseId,
      });

      this.closeModal();
    }

    this.isFetchingBreakpoints = false;
  },
  methods: {
    closeModal(): void {
      this.$emit('onClose');
    },
  },
});
